export default "__VITE_ASSET__CT3in$VP__$_?url__"